import React from 'react';

import logo from '../../../../Assets/logo.svg';
import Dots from './Dots';
import {
    Link,
    Theme,
    makeStyles,
    createStyles,
    AppBar,
    Toolbar,
    Collapse,
    useMediaQuery,
    useTheme,
    IconButton,
} from '@material-ui/core';
import Navigation from './Navigation';
import MenuIcon from '@material-ui/icons/Menu';
import { useSelector } from 'react-redux';
import { RootState } from '../../../core/store';
import { QueryClient, QueryClientProvider } from 'react-query';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            marginBottom: theme.spacing(5),
        },
        appBar: {
            backgroundColor: 'rgb(141, 217, 200)',
            position: 'relative',
            zIndex: theme.zIndex.drawer + 1,
        },
        toolbar: {
            justifyContent: 'space-between',
            padding: '5px 1rem',

            [theme.breakpoints.up('lg')]: {
                padding: '5px 6.5rem',
            },
        },
        brandLogo: {
            height: 25,

            [theme.breakpoints.up('sm')]: {
                height: 50,
            },
        },
        brandLink: {
            fontSize: 20,
            color: '#0d273e',
            textDecoration: 'none',

            [theme.breakpoints.up('sm')]: {
                fontSize: 32,
                margin: '0 auto 0 1rem',
            },
            '&:hover': {
                textDecoration: 'none',
            },
        },
        desktopNavigation: {
            display: 'flex',
        },
    }),
);

const AppNavbar = () => {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const [open, setOpen] = React.useState(false);
    const queryClient = new QueryClient();

    const handleDropdown = () => {
        setOpen(!open);
    };
    const showNav = useSelector((state: RootState) => state.navbar.showNavbar);
    const loading = useSelector((state: RootState) => state.navbar.loading);

    return (
        <>
            <QueryClientProvider client={queryClient}>
                {showNav && !loading ? (
                    <div className={classes.root}>
                        <AppBar className={classes.appBar} position="static">
                            <Toolbar className={classes.toolbar}>
                                <Link href={process.env.REACT_APP_DASHBOARD_LINK || '#'}>
                                    <img className={classes.brandLogo} alt="Brand Logo" src={logo} />
                                </Link>
                                <Link className={classes.brandLink} href={process.env.REACT_APP_DASHBOARD_LINK || '#'}>
                                    OneCDE
                                </Link>
                                {matches ? (
                                    <Navigation className={classes.desktopNavigation} />
                                ) : (
                                    <IconButton color="inherit" onClick={handleDropdown}>
                                        <MenuIcon />
                                    </IconButton>
                                )}
                            </Toolbar>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <Navigation />
                            </Collapse>
                            <Dots />
                        </AppBar>
                    </div>
                ) : (
                    ''
                )}
            </QueryClientProvider>
        </>
    );
};

export default AppNavbar;
